import React from 'react';
import * as ProfileInfoElement from '..';
import * as ProfileInterface from '../../../../interfaces/profile.interface';
import * as DetailProfileInfoFC from '../../../../components/elements/profile/detail-each-profile-info';
import ProfileInfoTemplate from '../../../templates/ProfileInfoTemplate';

const ProfileSection: React.FunctionComponent<
  ProfileInterface.IProfileSectionProps
> = ({
  roleView,
  bio,
  school,
  experience,
  certificate,
  reward,
  scientific,
  volunteeringActivity,
  project,
  setModal,
}) => {
  return (
    <>
      <div className="group lg:bg-white lg:px-3 lg:pb-2 lg:rounded-lg lg:my-4 lg:shadow-[0px_10px_20px_rgba(0,0,0,0.05)]">
        <div className="flex justify-between">
          <ProfileInfoElement.ProfileInfoTitle title="Giới thiệu" />
          <div className="self-center flex lg:hidden group-hover:flex lg:justify-center">
            <ProfileInfoElement.ProfileInfoEditButton
              setModal={setModal}
              value={bio}
              modalName={ProfileInterface.UserSettingEnum.Introduction}
              roleView={roleView}
            />
          </div>
        </div>

        <DetailProfileInfoFC.BioComponent data={{ bio }} />
      </div>

      <div className="lg:bg-white lg:p-3 lg:rounded-lg lg:my-4 lg:shadow-[0px_10px_20px_rgba(0,0,0,0.05)]">
        <ProfileInfoTemplate
          initData={school}
          DetailProfileInfoFC={DetailProfileInfoFC.SchoolComponent}
          roleView={roleView}
          modalName={ProfileInterface.UserSettingEnum.School}
          addButonContent={'Thêm một học vấn'}
          title={'Học vấn'}
          setModal={setModal}
        />
      </div>

      <div className="lg:bg-white lg:p-3 lg:rounded-lg lg:my-4 lg:shadow-[0px_10px_20px_rgba(0,0,0,0.05)]">
        <ProfileInfoTemplate
          initData={experience}
          DetailProfileInfoFC={DetailProfileInfoFC.ExperienceComponent}
          roleView={roleView}
          modalName={ProfileInterface.UserSettingEnum.Experience}
          addButonContent={'Thêm một kinh nghiệm'}
          title={'Kinh nghiệm'}
          setModal={setModal}
        />
      </div>

      <div className="lg:bg-white lg:p-3 lg:rounded-lg lg:my-4 lg:shadow-[0px_10px_20px_rgba(0,0,0,0.05)]">
        <ProfileInfoTemplate
          initData={project}
          DetailProfileInfoFC={DetailProfileInfoFC.ProjectComponent}
          roleView={roleView}
          modalName={ProfileInterface.UserSettingEnum.Project}
          addButonContent={'Thêm một dự án'}
          title={'Dự án'}
          setModal={setModal}
          intro
          introContent="Bạn đã tham gia những dự án nào? Thêm ngay tại đây."
        />
      </div>

      <div className="lg:bg-white lg:p-3 lg:rounded-lg lg:my-4 lg:shadow-[0px_10px_20px_rgba(0,0,0,0.05)]">
        <ProfileInfoTemplate
          initData={certificate}
          DetailProfileInfoFC={DetailProfileInfoFC.CertificateComponent}
          roleView={roleView}
          modalName={ProfileInterface.UserSettingEnum.Certificate}
          addButonContent={'Thêm một chứng chỉ'}
          title={'Chứng chỉ'}
          setModal={setModal}
        />
      </div>

      <div className="lg:bg-white lg:p-3 lg:rounded-lg lg:my-4 lg:shadow-[0px_10px_20px_rgba(0,0,0,0.05)]">
        <ProfileInfoTemplate
          initData={scientific}
          DetailProfileInfoFC={DetailProfileInfoFC.ScientificComponent}
          roleView={roleView}
          modalName={ProfileInterface.UserSettingEnum.Scientific}
          addButonContent={'Thêm một công bố khoa học'}
          title={'Công bố khoa học'}
          setModal={setModal}
        />
      </div>

      <div className="lg:bg-white lg:p-3 lg:rounded-lg lg:my-4 lg:shadow-[0px_10px_20px_rgba(0,0,0,0.05)]">
        <ProfileInfoTemplate
          initData={reward}
          DetailProfileInfoFC={DetailProfileInfoFC.AwardComponent}
          roleView={roleView}
          modalName={ProfileInterface.UserSettingEnum.Award}
          addButonContent={'Thêm một giải thưởng'}
          title={'Giải thưởng'}
          setModal={setModal}
        />
      </div>

      <div className="lg:bg-white lg:p-3 lg:rounded-lg lg:my-4 lg:shadow-[0px_10px_20px_rgba(0,0,0,0.05)]">
        <ProfileInfoTemplate
          initData={volunteeringActivity}
          DetailProfileInfoFC={
            DetailProfileInfoFC.VolunteeringActivityComponent
          }
          roleView={roleView}
          modalName={ProfileInterface.UserSettingEnum.Volunteer}
          addButonContent={'Thêm một hoạt động tình nguyện'}
          title={'Hoạt động xã hội & tình nguyện'}
          setModal={setModal}
          intro
          introContent="Bạn đã tham gia hoạt động tình nguyện nào? Thêm ngay tại đây."
        />
      </div>
    </>
  );
};

export default ProfileSection;
